import logoutRepository from '../repositories/logoutRepository';

const logoutService = {
  invalidateToken: async () => {
    return await logoutRepository.invalidateToken();
  }
};

export default logoutService;
